import React from "react";

const Footer = () => {
  return (
    <footer className="bg-grey-lightest justify-center h-16 flex flex-col">
      <p className="self-center text-blue-darker">
        © {new Date().getFullYear()}
        {`-`}
        <a
          href="https://www.jandrade.co"
          className="text-blue-darker hover:text-orange-lightest no-underline"
        >
          Juan Francisco Andrade
        </a>
      </p>
    </footer>
  );
};

export default Footer;
